/**
 * @generated SignedSource<<0e748104263cd0d0383e0b146be43155>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contactBaseInlineFragment$data = {
  readonly id: string;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly source: string;
  readonly userId: string | null;
  readonly unmindUserId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"contactSessionLimitsRemainingInlineFragment">;
  readonly " $fragmentType": "contactBaseInlineFragment";
};
export type contactBaseInlineFragment$key = {
  readonly " $data"?: contactBaseInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactBaseInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "contactBaseInlineFragment"
};

(node as any).hash = "19c5cbdf70431eef60a8073b47999def";

export default node;
